import { Register } from 'api';

export const registerFetcher = userDetails => {
  return Register.post(userDetails);
};
